"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avenirBoldItalic = exports.avenirBold = exports.avenirDemiItalic = exports.avenirDemi = exports.avenirItalic = exports.avenirRegular = exports.avenirLightItalic = exports.avenirLight = void 0;

// Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​
var avenirLight = function avenirLight() {
  return "\n    font-weight: 300;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirLight = avenirLight;

var avenirLightItalic = function avenirLightItalic() {
  return "\n    font-weight: 300;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirLightItalic = avenirLightItalic;

var avenirRegular = function avenirRegular() {
  return "\n    font-weight: 400;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirRegular = avenirRegular;

var avenirItalic = function avenirItalic() {
  return "\n    font-weight: 400;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirItalic = avenirItalic;

var avenirDemi = function avenirDemi() {
  return "\n    font-weight: 500;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirDemi = avenirDemi;

var avenirDemiItalic = function avenirDemiItalic() {
  return "\n    font-weight: 500;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirDemiItalic = avenirDemiItalic;

var avenirBold = function avenirBold() {
  return "\n    font-weight: 600;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirBold = avenirBold;

var avenirBoldItalic = function avenirBoldItalic() {
  return "\n    font-weight: 600;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirBoldItalic = avenirBoldItalic;